import StoreModule from "./store_module";
import _ from "lodash";
import Vue from "vue";

// The name of this store module.
const name = "mot";

const actions = {
	SET_MOT_VARIABLE: ({ commit }, { name, payload }) =>
		commit("SET_MOT_VARIABLE", { name, payload }),
	SET_MOT_VM: ({ commit }, { name, payload }) =>
		commit("SET_MOT_VM", { name, payload }),
	SET_SITEBAR_LIST: ({ commit }, payload) => commit("SET_SITEBAR_LIST", payload)
};
const mutations = {
	SET_TITLE(state, payload) {
		state.MOTtitle = payload;
	},
	SET_MOT_ViewModal(state, payload) {
		state.MOTViewModal = payload;
	},
	SET_MOT_ID(state, payload) {
		state.MOTId = payload;
	},
	SET_PROJECT_ID(state, payload) {
		state.ProjectId = payload;
	},
	SET_PROJECT_NUM(state, payload) {
		state.ProjectNum = payload;
	},
	SET_MOT_STATUS(state, payload) {
		state.MOTStatus = payload;
	},
	SET_MOT_START_YEAR(state, payload) {
		let startyear = payload;
		startyear = new Date(parseInt(startyear), 0, 1);
		state.MOTConstructionStartYear = startyear;
	},
	SET_MOT_END_YEAR(state, payload) {
		let endyear = payload;
		endyear = new Date(parseInt(endyear), 11, 31);
		state.MOTConstructionEndYear = endyear;
	},
	SET_MOT_DATA(state, payload) {
		state.MOTData = payload;
	},

	SET_COMPONENT(state, payload) {
		Vue.set(state, "MOTcomponent", payload);
	},
	SET_ISAPPROVED_FLAG(state, payload) {
		state.MOTIsApprovedFlag = payload;
	},
	SET_TEXT_TITLE(state, payload) {
		state.MOTtextTitle = payload;
	},
	SET_NAVIGATION_ID(state, payload) {
		state.MOTnavigationId = payload;
	},
	SET_MOT_INFO_UPDATING_FLAG(state, payload) {
		state.MOTInfoUpdatingFlag = payload;
	},
	SET_SITEBAR_LIST(state, payload) {
		state.MOTsidebarList = payload;
	},
	SET_SECTION_VAR(state, payload) {
		state.MOTSectionVariable = payload;
	},
	SET_MOT_TABLE_DATA(state, { name, payload }) {
		Vue.set(state.MOTViewModal, name, payload);
	},

	SET_MOT_VM(state, { name, payload }) {
		Vue.set(state.MOTViewModal, name, payload);
	}
};
const getters = {
	MOTId: state => state.MOTId,
	ProjectId: state => state.ProjectId,
	ProjectNum: state => state.ProjectNum,
	MOTStatus: state => state.MOTStatus,
	MOTConstructionStartYear: state => state.MOTConstructionStartYear,
	MOTConstructionEndYear: state => state.MOTConstructionEndYear,
	MOTtitle: state => state.MOTtitle,
	MOTsidebarList: state => state.MOTsidebarList,
	MOTcomponent: state => state.MOTcomponent,
	MOTData: state => state.MOTData,
	MOTInfoUpdatingFlag: state => state.MOTInfoUpdatingFlag,
	MOTSectionVariable: state => state.MOTSectionVariable,
	MOTIsApprovedFlag: state => state.MOTIsApprovedFlag,
	MOTtextTitle: state => state.MOTtextTitle,
	MOTnavigationId: state => state.MOTnavigationId,
	MOTViewModal: state => state.MOTViewModal
};
const initialState = {
	MOTtitle: null,
	MOTsidebarList: {},
	MOTData: null,
	MOTSectionVariable: null,
	MOTIsApprovedFlag: null,
	MOTtextTitle: null,
	MOTnavigationId: null,
	MOTId: 0,
	ProjectId: 0,
	ProjectNum: null,
	MOTStatus: null,
	MOTConstructionStartYear: null,
	MOTConstructionEndYear: null,
	MOTViewModal: {},
	MOTInfoUpdatingFlag: false
};

const Mot = new StoreModule(
	name,
	mutations,
	actions,
	getters,
	_.cloneDeep(initialState)
);

export default Mot;
